export default __webpack_public_path__ + "static/media/kitaplar-btn.168fed70.svg";